<div class="card d-flex container-packing">
  <form-row-select
    class="width-200"
    [label]="'product.count-by'"
    [model]="selectedCountBy"
    (modelChange)="selectedCountByChanged($event)"
    [options]="countByOptions">
  </form-row-select>
  <form-row-input
    class="width-200"
    *ngIf="selectedCountBy === 'by-piece'"
    [label]="'product.pieces-in-pack'"
    [inputType]="'number'"
    [(model)]="productDetailService.piecesInPack">
  </form-row-input>
  <div class="container-prices">
    <form-row-input
      class="width-230"
      *ngIf="selectedCountBy === 'by-piece'"
      [label]="productDetailService.isCountByPiece ? 'purchasePrice.default.by-pack' : 'purchasePrice.default'"
      [class]="'input-unit'"
      [icon]="'fa-money-bill'"
      [(model)]="productDetailService.product.purchasePrice"
      [replaceComma]="true"
      [currency]="productDetailService.product.purchaseCurrency"
      [appendUnitCurrency]="true"
      [readonly]="!productDetailService.hasUpdateRole"
      data-cy="product-price-default">
    </form-row-input>
    <form-row-input
      class="width-230"
      *ngIf="selectedCountBy === 'by-piece'"
      [label]="'purchasePrice.default.by-piece'"
      [class]="'input-unit'"
      [icon]="'fa-money-bill'"
      [(model)]="productDetailService.purchasePriceByPiece"
      [replaceComma]="true"
      [currency]="productDetailService.product.purchaseCurrency"
      [appendUnitCurrency]="true"
      [readonly]="!productDetailService.hasUpdateRole"
      data-cy="product-price-default">
    </form-row-input>
  </div>
</div>
